module.exports = __webpack_public_path__ + "team yungol.svg?b30c5e283d3376732600017f2579f1f5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/team yungol.svg
// module id = 464
// module chunks = 0